module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('button', {
    class: _vm.setClass(),
    attrs: {
      "id": "gv-button-genio-conferma-load-shape",
      "title": "Conferma"
    },
    on: {
      "click": _vm.onClick
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-03a1ffe3!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/buttons/GenioConfermaLoadShape.vue
// module id = 814
// module chunks = 39